import React from 'react'
import { compose } from 'recompose'
import { ThemeProvider, withTheme } from 'styled-components'

export default compose(
  (WrappedComponent) => (
    ({ theme, ...props }) => (
      <ThemeProvider theme={theme}>
        <WrappedComponent {...props} />
      </ThemeProvider>
    )
  ),
  withTheme,
)



// WEBPACK FOOTER //
// ./src/hocs/bases/withTheme.js